import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { FailedSolutions } from '../components/FailedSolutions';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGet } from '../components/WhatYouGet';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-white font-sans text-[#1A1A1A] selection:bg-[#E8F5E2] selection:text-[#2D5A27]" data-id="element-210">
      <HeroSection data-id="element-211" />
      <ProblemSection data-id="element-212" />
      <FailedSolutions data-id="element-213" />
      <MechanismSection data-id="element-214" />
      <WhatYouGet data-id="element-215" />
      <AudienceSection data-id="element-216" />
      <HowItWorks data-id="element-217" />
      <ProofSection data-id="element-218" />
      <FAQSection data-id="element-219" />
      <OfferSection data-id="element-220" />

      <Footer data-id="element-221" />
    </main>;
}